  var __isp_options = {
      isp_serp_callback: function() {

        $('.isp_product_price_wrapper').css({'display':'none'});
        
        var hideproduct = [];
        $('.isp_grid_product').each(function(index) {
          var isp_variants_options = new Object;
          var p_id = $(this).attr('product_id');

          var han = $(this).find('.isp_product_image_href').attr('href');
          $(this).find('.isp_quick_view_description').css({'display':'none'});

          var han = han.substring(han.lastIndexOf("/") + 1, han.length);

          var str1 = han;
          var str2 = "?";
          if(str1.indexOf(str2) != -1){
            var han = han.substring(0 , han.indexOf('?'));
          }

          var cust = '{{ customer.name }}';

          
            $.getJSON('/products/'+han+'.js', function(product) {
              var tgs = product.tags;
              for(var i = 0; i < tgs.length; i++) {
                if ((tgs[i] == 'MUSTCALL-YES')){
                   $('.isp_grid_product').each(function(index) {
                    var p_id = $(this).attr('product_id');
                    if(p_id==product.id){
                      $(this).find('.isp_product_price_wrapper').css({'display':'block'});
                      $(this).find('.isp_product_price_wrapper').html('<span style="font-size: 15px;color: #8b1e41 !important;font-weight: bold;" class="login-to">Must Call To Order</span>');
                      $(this).find('.isp_add_to_cart_form').hide();
                      $(this).find('.isp_product_quick_view_button').hide();
                      $(this).find('.swym-button').hide();
                      hideproduct.push(product.id);
                    }
                  });
                }else if((tgs[i] == 'HIDEPRICEBEFORELOGIN') && (cust=='')){
                  $('.isp_grid_product').each(function(index) {
                    var p_id = $(this).attr('product_id');
                    if(p_id==product.id){
                      $(this).find('.isp_product_price_wrapper').css({'display':'block'});
                      $(this).find('.isp_product_price_wrapper').html('<span style="font-size: 14px;font-family: Barlow;font-weight: 500;color: #272727;" class="login-to">{{ settings.hide_price_before_login_text }}</span>');
                      $(this).find('.isp_add_to_cart_form').hide();
                      $(this).find('.isp_product_quick_view_button').hide();
                      $(this).find('.swym-button').hide();
                      hideproduct.push(product.id);
                    }
                  });                
                }
              }
              if(hideproduct!=''){
                for(var i = 0; i < hideproduct.length; i++) {
                  if (hideproduct[i] != p_id){

                    $('.isp_grid_product').each(function(index) {

                      $(this).find('.isp_product_price_wrapper').css({'display':'block'});

                    });


                  }
                }
              }else{
                $('.isp_grid_product').each(function(index) {

                  $(this).find('.isp_product_price_wrapper').css({'display':'block'});

                });
              }


            });



         
          //$(this).find('.isp_product_price_wrapper').css({'display':'block'});
        });

        $('.isp_facet_value_name_not_selected').each(function(){
          var get_text = $(this).text();
          if((get_text=='CORE VALUES')||(get_text=='CREATED WITH CARE')||(get_text=='NEW')||(get_text=='INTERNATIONAL VOLTAGE')){
            $(this).text(get_text.toLowerCase());
            $(this).css({'text-transform': 'capitalize'});
          }else if(get_text=='PACKAGED FOR RETAIL'){
            $(this).text('Packaged For Retail');
          }else if(get_text=='CE MARKED'){
            $(this).text('CE Marked');
          }else if(get_text=='UL LISTED'){
            $(this).text('UL Listed');
          }else if(get_text=='Eco-Fin'){
            $(this).text('Eco-fin');
          }

        });

        $('.isp_facet_value_name_selected').each(function(){
          var get_text = $(this).text();
          if((get_text=='CORE VALUES')||(get_text=='CREATED WITH CARE')||(get_text=='NEW')||(get_text=='INTERNATIONAL VOLTAGE')){
            $(this).text(get_text.toLowerCase());
            $(this).css({'text-transform': 'capitalize'});
          }else if(get_text=='PACKAGED FOR RETAIL'){
            $(this).text('Packaged For Retail');
          }else if(get_text=='CE MARKED'){
            $(this).text('CE Marked');
          }else if(get_text=='UL LISTED'){
            $(this).text('UL Listed');
          }else if(get_text=='Eco-Fin'){
            $(this).text('Eco-fin');
          }

        });


        $('.isp_facet_title_name').each(function(){
          var get_text = $(this).text();
          if(get_text=='Packaged for Retail'){
            $(this).text('Packaged For Retail');
          }

        });

      },
      isp_serp_quickview_callback: function() {
        //$('.isp_quick_view_description').html("");
        
        	$(".isp_quick_view_description").html(function (_, ctx) {
              return ctx.replace("Description", "<b>Description: </b>");
            });
        	$(".isp_quick_view_description").html(function (_, ctx) {
                return ctx.replace("Purpose and Benefits", "<br/><b>Purpose and Benefits: </b>");
            });
        	$(".isp_quick_view_description").html(function (_, ctx) {
                return ctx.replace("Ingredients", "<br/><b>Ingredients: </b>");
            });
        
        	$(".isp_quick_view_show_more").html("View full product details");
        	$(".isp_quick_view_show_more").insertAfter($(".isp_quick_view_image_wrapper"));
        
        	$(".isp_quick_view_add_to_cart_form").append('<div class="quick-chk grid__item large--one-whole checkout--icons-product medium-down--hide"><img alt="Checkout Secure" src="//cdn.shopify.com/s/files/1/0090/8653/3689/t/20/assets/checkout_icon.png?15011" class="no-border checkout-img checkout-img"></div>');
        	$("#isp_product_quick_view_close_button").html('<i class="fa fa-times"></i>');
        
        	/*$('.isp_add_to_cart_quantity_num').remove();
        	$('.isp_add_to_cart_quantity').append('<div class="js-qty"><button type="button" class="qty-adjust js-qty__adjust js-qty__adjust--minus icon-fallback-text" data-id="minus" data-qty="0"><span class="icon icon-minus" aria-hidden="true"></span><span class="fallback-text" aria-hidden="true">−</span><span class="visually-hidden">Reduce item quantity by one</span></button><input type="text" class="js-qty__num " value="1" min="1" data-id="" aria-label="quantity" pattern="[0-9]*" name="quantity" id="quantity"><button type="button" class="qty-adjust js-qty__adjust js-qty__adjust--plus icon-fallback-text" data-id="plus" data-qty="11"><span class="icon icon-plus" aria-hidden="true"></span><span class="fallback-text" aria-hidden="true">+</span><span class="visually-hidden">Increase item quantity by one</span></button></div>');*/
       } 
    }
  
  
  
  if(document.location.href.indexOf('?m_page_count=200&q=lp_new_arrival') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/new-arrivals';
} else if(document.location.href.indexOf('?m_page_count=200&q=ByTreatmentFace') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/skin-care-products';
} else if(document.location.href.indexOf('?m_page_count=200&q=ByTreatmentHands') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/manicure-pedicure';
} else if(document.location.href.indexOf('?m_page_count=200&q=ByTreatmentMassage') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/massage';
} else if(document.location.href.indexOf('?m_page_count=200&q=BySpecialsViewAll') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/new-arrivals';
} else if(document.location.href.indexOf('?q=lp_MothersDay2019') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/embraceable-you';
} else if(document.location.href.indexOf('?q=lp_SpaRitualVibrantEnergy') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/spa-ritual';
} else if(document.location.href.indexOf('?m_page_count=48&q=ByTreatmentMakeup') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/makeup';
} else if(document.location.href.indexOf('?m_page_count=48&q=lp_BestInShow') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/spa-ritual';
} else if(document.location.href.indexOf('?q=lp_lashandbrow') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/lash-brow';
} else if(document.location.href.indexOf('?q=lp_kissablelips') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/lip-products-blushes';
} else if(document.location.href.indexOf('?q=lp_facialmasks') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/exfoliants-peels-masks-scrubs';
} else if(document.location.href.indexOf('?q=lp_loveyourlips') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/lip-products-blushes';
} else if(document.location.href.indexOf('?q=lp_treatmentlash') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/lash-brow';
} else if(document.location.href.indexOf('?q=lp_himalayansalt') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/salt-lamps';
} else if(document.location.href.indexOf('?m_page_count=200&q=Byareamanipedi') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/manicure-pedicure';
} else if(document.location.href.indexOf('?m_page_count=200&q=Bytreatmentwaxing') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/all-wax-hair-removal-brands';
} else if(document.location.href.indexOf('?q=lp_waxingtools') > -1) {
	document.location.href = 'https://www.universalcompanies.com/collections/waxing-supplies-tools';
}